module.exports = __webpack_public_path__ + "img/Login-Seite-Unten_2.0a2d741c.webp";